import styled from '@emotion/styled';
import tw from 'twin.macro';
import { ImageElement } from '@kontent-ai/gatsby-components';

export const StyledAuthorInfo = styled.div`
  ${tw`relative`}
  ${tw`flex flex-col`}
  ${tw`md:flex-row`}
  ${tw`mr-0`}
  &:before {
    ${tw`md:content-[""]`}
    ${tw`block`}
    ${tw`absolute`}
    ${tw`top-0 bottom-0 right-0`}
    ${tw`text-secondary-s1`}
    ${tw`border-r`}
  }
`;

export const StyledAvatar = styled.figure`
  ${tw`w-[48px]`}
  ${tw`h-[48px]`}
  ${tw`mr-2 mb-2 md:mb-0`}
`;

export const StyledDetails = styled.div`
  ${tw`flex flex-col justify-center`}
  ${tw`relative`}
  ${tw`pr-0 md:pr-1`}
  ${tw`w-[247px]`}
`;

export const StyledName = styled.p`
  ${tw`font-poppins font-semi-bold`}
  ${tw`text-tag-l text-primary-p1`}
  ${tw`mb-[4px]`}
`;

export const StyledTag = styled.p`
  ${tw`text-neutrals-n7 text-tag-s`}
  ${tw`font-semi-bold`}
`;

export const StyledImageElement = styled(ImageElement)`
  ${tw`w-full m-0`}
`;
